"use strict";

exports.__esModule = true;
var _ReportRoutes = require("./ReportRoutes");
Object.keys(_ReportRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportRoutes[key]) return;
  exports[key] = _ReportRoutes[key];
});